import { render, staticRenderFns } from "./OptionsHorizontal.vue?vue&type=template&id=6f5c6043&scoped=true&"
import script from "./OptionsHorizontal.vue?vue&type=script&lang=js&"
export * from "./OptionsHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c6043",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VFlex})
